import React from "react";
import { connect } from "react-redux";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import eventAdvertise from "../../../store/actions/eventAdvertise";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
} from "recharts";

const BarChartReport = ({ dataChartStateRedux, eventDataChart }) => {
  const dataChart = [];
  for (const key in dataChartStateRedux) {
    dataChart.push({
      day: helpersNumbers
        .toPersianNum(helpersTime.convertGregorianToJalali(key, "MMMM DD ddd"))
        .split(" ")
        .reverse()
        .join(" "),
      value: dataChartStateRedux[key],
    });
  }

  const customizedTooltip = ({ label, payload, active, chartType }) => {
    if (!active) {
      return <></>;
    }
    if (payload == undefined) {
      return <></>;
    }

    if (payload[0] == undefined) {
      return <></>;
    }

    return (
      <div className="card " id="box-details-line-chart" dir="rtl">
        <div className="card-body p-3">
          {" "}
          <div className="d-flex justify-content-between pb-3">
            <span className="pl-2">
              {
                eventAdvertise.eventAdvertisePersian[
                  eventDataChart.toUpperCase()
                ]
              }{" "}
              :
            </span>
            <span>{helpersNumbers.toPersianNum(payload[0].value)}</span>
          </div>
          <div className="d-flex justify-content-between ">
            <span className="pl-2">زمان : </span>
            <span className="pr-2">{label}</span>
          </div>
        </div>
      </div>
    );
  };

  const customizeLabelYAxis = (value) => {
    return helpersNumbers.toPersianNum(value);
  };

  return (
    <ResponsiveContainer width="100%" aspect={2}>
      <ComposedChart data={dataChart}>
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis dataKey="day" padding={{ left: 20, right: 20 }} />
        <YAxis tickFormatter={customizeLabelYAxis} />
        <Tooltip content={customizedTooltip} />
        <Bar barCategoryGap="10%" dataKey="value" barSize={15} fill="#7fdf64" />
        <Line type="monotone" dataKey="value" stroke="#007BFF" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    dataChartStateRedux: state.reportCampaign.data_chart,
    eventDataChart: state.reportCampaign.event_data_chart,
  };
};

export default connect(mapStateToProps, null)(BarChartReport);
